module.exports = __webpack_public_path__ + "img/banner-3.38d2bd06.jpg";